module.exports = __webpack_public_path__ + "static/media/item6.240c51ca.jpg";